//Customer subscription status
export const SUBSCRIPTIONS_STATUS_WAITINGFORPAYMENT = 'WaitingForPayment';
export const SUBSCRIPTIONS_STATUS_AUTOCANCELLED = 'AutoCancelled';
export const SUBSCRIPTIONS_STATUS_ACTIVE = 'Active';
export const SUBSCRIPTIONS_STATUS_TOBEEXPIRED = 'ToBeExpired';
export const SUBSCRIPTIONS_STATUS_CANCELLED = 'Cancelled';
export const SUBSCRIPTIONS_STATUS_EXPIRED = 'Expired';
export const SUBSCRIPTIONS_STATUS_GRACEPERIOD = 'GracePeriod';
export const SUBSCRIPTIONS_STATUS_UPCOMING = 'Upcoming';

